import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  ["Home", "/"],
  ["About", "/about"],
  ["Services", "/services"],
  ["Projects", "/projects"],
  ["Contact", "/contact"],
];

export const MobileNav = ({
  buttonClassName = "rounded-full bg-[#163323] p-2 text-white lg:hidden",
  hideClass = "lg:hidden",
}) => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <>
      <button
        data-testid="mobile-menu-btn"
        aria-label="Open navigation menu"
        onClick={() => setOpen(true)}
        className={buttonClassName}
      >
        <Menu className="h-5 w-5" />
      </button>

      {open && (
        <div className={`fixed inset-0 z-[100] ${hideClass}`} data-testid="mobile-menu-overlay">
          <div
            className="absolute inset-0 bg-black/50 backdrop-blur-sm"
            onClick={close}
          />
          <nav className="absolute right-0 top-0 flex h-full w-72 max-w-[80%] flex-col bg-[#163323] px-6 py-6 text-white shadow-2xl">
            <div className="mb-8 flex items-center justify-between">
              <span className="font-serif text-sm font-semibold uppercase tracking-[0.2em] text-[#c8a452]">
                Menu
              </span>
              <button
                data-testid="mobile-menu-close"
                aria-label="Close navigation menu"
                onClick={close}
                className="rounded-full p-1.5 text-white/80 transition-colors hover:bg-white/10 hover:text-white"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            <div className="flex flex-col gap-1">
              {LINKS.map(([label, href]) =>
                href.startsWith("/") ? (
                  <Link
                    key={label}
                    to={href}
                    onClick={close}
                    data-testid={`mobile-nav-${label.toLowerCase()}`}
                    className="rounded-lg px-3 py-3 text-base font-medium text-white/85 transition-colors hover:bg-white/10 hover:text-white"
                  >
                    {label}
                  </Link>
                ) : (
                  <a
                    key={label}
                    href={href}
                    onClick={close}
                    data-testid={`mobile-nav-${label.toLowerCase()}`}
                    className="rounded-lg px-3 py-3 text-base font-medium text-white/85 transition-colors hover:bg-white/10 hover:text-white"
                  >
                    {label}
                  </a>
                )
              )}
            </div>
          </nav>
        </div>
      )}
    </>
  );
};
